import React, { Fragment, useEffect, useState } from "react";
import { toastr } from "react-redux-toastr";
import ErrorMessage from "../../../../components/text/ErrorMessage";
// import {
//     Lead,
// } from "../../../../core/api/models";
import {
  City,
  CityZone,
  CityLocation,
  RequirementResponseData,
  Lead,
} from "../../../../core";

import "react-widgets/dist/css/react-widgets.css";
import api from "../../../../api";
import NewRequirementPreview from "./NewRequirementPreview";
import TabComponent from "./TabComponent";
import RequirementDetails from "./RequirementDetails";
import NewRequirementForm from "./NewRequirementForm";
import RequirementVersionsComparison from "./RequirementVersionsComparison";
import { RouteKeys } from "../../../routes/route-keys";
import { useHistory } from "react-router-dom";
interface ObjectType {
  value: string;
  name: string;
}

interface FormData {
  city: ObjectType;
  microMarkets: string[];
  preferredLocations: string[];
  propertyType: ObjectType;
  projectType: ObjectType;
  minPrice: ObjectType;
  maxPrice: ObjectType;
  minArea: string;
  maxArea: string;
  earliestMoveInDate: string;
  lastMoveInDate: string;
  preferedDate: string;
  floorPreferences: string[];
  preferedProjects: string[];
  preferredDevelopers: string[];
  constructionStatus: string[];
  carParking: string;
  powerBackup: string;
  grade: string;
  // certification: string[];
  amenities: string[];
  // leaseExpiry: string;
}

const initialData = {
  city: "",
  microMarkets: [],
  preferredLocations: [],
  propertyType: "",
  projectType: [],
  minPrice: "",
  maxPrice: "",
  minArea: "",
  maxArea: "",
  minSeats: "",
  maxSeats: "",
  weightage: "",
  earliestMoveInDate: "",
  lastMoveInDate: "",
  floorPreferences: [],
  preferedProjects: [],
  preferredDevelopers: [],
  constructionStatus: [],
  carParking: "",
  powerBackup: "",
  grade: "",
  certification: [],
  amenities: [],
  proposalDueBy: "",
  facilityType: "",
  interiorType: [],
  proposalFormatType: "",
  proposalContentType: "",
  specialRequirements: "",
  forecast: "",
  certainity: "",
  constructionCompletionDate: "",
  includeGradeC: "",
  includeLeaseExpiry: ""
  // leaseExpiry: '',
};

const AddNewRequirements: React.FC<{
  lead?: Lead;
  leadId?: string;
  customerId?: string;
  onClose?: () => void;
  className?: string;
  onReload?: () => void;
}> = (props) => {
  const history = useHistory();
  const [cities, setCities] = useState<any>([]);
  const [microMarketsData, setMicroMarketsData] = useState<any>([]);
  const [preferredLocationsData, setPreferredLocationsData] = useState<any>([]);
  const [projectType, setProjectType] = useState<any>([]);
  const [propertyType, setPropertyType] = useState<any>([]);
  // const [preferredProjectType, setPreferredProjectType] = useState<any>([]);
  const [preferredDevelopers, setPreferredDevelopers] = useState<any>([]);
  const [floorPreferences, setFloorPreferences] = useState<any>([]);
  const [preferredProject, setPeferredProject] = useState<any>([]);
  const [amenities, setAmenities] = useState<any>([]);
  const [facilities, setFacilities] = useState<any>([]);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isRequirementEdit, setIsRequirementEdit] = useState<boolean>(false);
  const [showForm, setShowForm] = useState<boolean>(false);
  const [formData, setFormData] = useState<any>(initialData);
  const [
    confirmResData,
    setConfirmResData,
  ] = useState<RequirementResponseData>();
  const [approvalButtonDiabled, setApprovalButtonDiabled] = useState<boolean>(
    false
  );
  const [enableActionButton, setEnableActionButton] = useState<boolean>(false);
  const [isReset, setIsReset] = useState<boolean>(false);
  const [resetForm, setResetForm] = useState<boolean>(false);
  const [parentId, setParentId] = useState<string>("");
  // const [loading, setLoading] = useState<boolean>(false);

  const { lead } = props;
  const companyId = lead?.company?._id || undefined;

  const decodeHtmlEntities = (html: string) => {
    const textarea = document.createElement("textarea");
    textarea.innerHTML = html;
    return textarea.value;
  };

  const [saving, setSaving] = useState<boolean>(false);

  useEffect(() => {
    const tempVal = {
      ...formData,
      city: lead?.cityDetails ? { name: lead?.cityDetails?.cityName, value: lead?.cityDetails?._id } : "",
      microMarkets: lead?.microMarketDetails?.map((ele: any) => ({ name: ele.cityZoneName, value: ele._id })) || [],
      preferredLocations: lead?.preferredLocationDetails?.map((ele: any) => ({ name: ele.cityLocName, value: ele._id })) || [],
      propertyType: lead?.propertyTypeDetails ? { name: decodeHtmlEntities(lead?.propertyTypeDetails?.propertyTypeName), value: lead?.propertyTypeDetails?._id } : "",
      projectType: lead?.projectTypeDetails?.map((ele: any) => ({ name: ele.propertyTypeName, value: ele._id })) || [],
      minPrice: lead?.minPrice || "",
      maxPrice: lead?.maxPrice || "",
      minArea: lead?.minArea || "",
      maxArea: lead?.maxArea || "",
      floorPreferences: lead?.floorPreferenceDetails?.map((ele: any) => ({ name: ele?.floorName, value: ele?.floorName })) || [],
      preferredDevelopers: lead?.preferedDeveloperDetails?.map((ele: any) => ({ name: ele.developer, value: ele._id })) || [],
      preferedProjects: lead?.preferedProjectDetails?.map((ele: any) => ({ name: ele.projectName, value: ele._id })) || [],
      weightage: lead?.weightage || ""
    }
    setFormData(tempVal);
    setShowForm(true)
  }, [])

  useEffect(() => {
    const fetchCityData = async () => {
      try {
        const cityData = await api.AddNewRequirement.loadAllCities();
        const cityOptions = cityData?.map((item: City) => ({
          value: item._id,
          name: decodeHtmlEntities(item?.cityName),
        }));
        cityOptions.sort((a, b) => a.name.localeCompare(b.name));
        setCities(cityOptions);
      } catch (error) {
        // console.log("Failed to fetch city data:", error);
      }

      try {
        const floorData = await api.AddNewRequirement.getPreferredFloor();
        const floorDataOptions = (floorData || [])
          .map((item: any) => ({
            value: item,
            name: item,
          }))
          .sort((a: { name: number }, b: { name: number }) => a.name - b.name);

        setFloorPreferences(floorDataOptions || []);
      } catch (error) {
        // console.log("Failed to fetch preferred floor:", error);
      }

      try {
        const developerData = await api.AddNewRequirement.getPreferredDevelopers(
          { search: "" }
        );
        const developerDataOptions = developerData?.map((item: any) => ({
          value: item._id,
          name: decodeHtmlEntities(item?.developer),
        }));
        setPreferredDevelopers(developerDataOptions);
      } catch (error) {
        // console.log("Failed to fetch preferred developers:", error);
      }

      try {
        const amenityData = await api.AddNewRequirement.getAmenity({
          search: "",
        });
        const amenityDataOptions = amenityData?.map((item: any) => ({
          value: item._id,
          name: decodeHtmlEntities(item?.amenity),
        }));
        setAmenities(amenityDataOptions);
      } catch (error) {
        // console.log("Failed to fetch amenities data:", error);
      }

      try {
        const facilityData = await api.AddNewRequirement.getFacilityType();
        const facilityOptions = facilityData?.map((item: any) => ({
          value: item._id,
          name: decodeHtmlEntities(item?.facilityType),
        }));
        setFacilities(facilityOptions);
      } catch (error) {
        // console.log("Failed to fetch facilityType data:", error);
      }
    };
    handlePropertyType();
    handleProjectType();

    fetchCityData();
  }, []);

  React.useEffect(() => {
    if (props.lead?.cities) {
      handleCityZones(props.lead.cities);
    }
  }, [props.lead?.cities]);

  // Load micro markets data from API based on selected city
  const handleCityZones = async (selectedCityId: string) => {
    handlePreferredLocationsChange(selectedCityId);
    handlePreferredProjectChange(selectedCityId);
    // handlePropertyType(selectedCityId);
    // handleProjectType();
    try {
      const microMarketsListData = await api.AddNewRequirement.getCityZones(
        selectedCityId
      );
      const cityZoneOptions = microMarketsListData?.map((item: CityZone) => ({
        value: item._id,
        name: decodeHtmlEntities(item?.cityZoneName),
        cityLocations: item.cityLocations,
      }));
      setMicroMarketsData(cityZoneOptions);
    } catch (error) {
      // console.log("Failed to fetch micro markets data:", error);
    }
  };

  // Load preferred locations data from API based on selected city
  const handlePreferredLocationsChange = async (selectedCityId: string) => {
    try {
      const preferredLocationsListData = await api.AddNewRequirement.getPreferedLocations(
        selectedCityId
      );
      const cityPreferedLocOptions = preferredLocationsListData?.map(
        (item: CityLocation) => ({
          value: item._id,
          name: decodeHtmlEntities(item?.cityLocName),
        })
      );
      setPreferredLocationsData(cityPreferedLocOptions);
    } catch (error) {
      // console.log("Failed to fetch preferred locations data:", error);
    }
  };
  const handlePreferredProjectChange = async (selectedCityId: string) => {
    try {
      const projectData = await api.AddNewRequirement.getPreferredProject({
        cityId: selectedCityId,
      });
      const projectDataOptions = projectData?.map((item: any) => ({
        value: item._id,
        name: decodeHtmlEntities(item?.projectName),
      }));
      setPeferredProject(projectDataOptions);
    } catch (error) {
      // console.log("Failed to fetch preferred project:", error);
    }
  };

  // Load property type data from API based on selected city
  const handlePropertyType = async () => {
    try {
      const propertyTypeData = await api.AddNewRequirement.getPropertyType();
      // let propertyTypeOptions = propertyTypeData?.map((item: CityLocation) => ({
      //     value: item.cityDetailsID,
      //     name: item.cityLocName,
      // }));

      const subTypes = propertyTypeData.reduce((acc: any, item: any) => {
        acc.push(
          ...item.subTypes.map(
            (subType: { _id: any; propertyTypeName: any }) => ({
              value: subType._id,
              name: decodeHtmlEntities(subType.propertyTypeName),
            })
          )
        );
        return acc;
      }, []);
      setPropertyType(subTypes);
      // setValue('preferredLocations', []);
    } catch (error) {
      // console.log("Failed to fetch property type data:", error);
    }
  };
  // Load project type data from API based on selected city
  const handleProjectType = async () => {
    try {
      const projectTypeData = await api.AddNewRequirement.getProjectType();
      const subTypes = projectTypeData.reduce((acc: any, item: any) => {
        if (item?.subTypes) {
          acc.push(
            ...item.subTypes.map(
              (subType: { _id: any; propertyTypeName: any }) => ({
                value: subType._id,
                name: decodeHtmlEntities(subType.propertyTypeName),
              })
            )
          );
        }
        return acc;
      }, []);
      setProjectType(subTypes);
    } catch (error) {
      // console.log("Failed to fetch project type data:", error);
    }
  };

  const getFormatedFormData = (fData: any) => {
    return {
      coreRequirementParameters: fData.coreRequirementParameters?.map((item: any) => item.value),
      coreRequirements: fData.coreRequirements?.map((item: any) => item.value),
      city: fData.city.value || lead?.cities,
      microMarkets: fData?.microMarkets?.map((item: any) => item.value),
      preferredLocations: fData?.preferredLocations?.map((item: any) => item.value),
      propertyType: fData.propertyType.value || undefined,
      projectType: fData.projectType?.map((pType: any) => pType.value) || undefined,
      // minPrice:
      //   (typeof fData.minPrice === "object"
      //     ? Number(fData?.minPrice?.value)
      //     : Number(fData?.minPrice)) || undefined,
      // maxPrice:
      //   (typeof fData.maxPrice === "object"
      //     ? Number(fData?.maxPrice?.value)
      //     : Number(fData?.maxPrice)) || undefined,
      minPrice: fData.minPrice || undefined,
      maxPrice: fData.maxPrice || undefined,
      minArea: fData.minArea || undefined,
      maxArea: fData.maxArea || undefined,
      earliestMoveInDate: fData.earliestMoveInDate
        ? new Date(Date.parse(fData.earliestMoveInDate))
        : undefined,
      lastMoveInDate: fData.lastMoveInDate
        ? new Date(Date.parse(fData.lastMoveInDate))
        : undefined,
      floorPreferences:
        fData.floorPreferences?.map((item: any) => item.value) || undefined,
      preferedProjects:
        fData.preferedProjects?.map((item: any) => item.value) || undefined,
      preferredDevelopers:
        fData.preferredDevelopers?.map((item: any) => item.value) || undefined,
      constructionStatus:
        fData.constructionStatus?.map((item: any) => item.value) || undefined,
      constructionCompletionDate: fData?.constructionCompletionDate || undefined,
      includeGradeC: fData.includeGradeC || false,
      includeLeaseExpiry: fData.includeLeaseExpiry || false,
      // carParking:
      //   fData.carParking !== undefined
      //     ? fData.carParking === "yes"
      //     : fData.carParking === "no"
      //       ? false
      //       : undefined,
      // powerBackup:
      //   fData.powerBackup !== undefined
      //     ? fData.powerBackup === "yes"
      //     : fData.powerBackup === "no"
      //       ? false
      //       : undefined,
      // grade: fData.grade || undefined,
      proposalFormatType: fData.proposalFormatType || undefined,
      proposalContentType: fData.proposalContentType || undefined,
      certainity: fData.certainity || undefined,
      forecast: fData.forecast || undefined,
      // certification: formData.certification.map((item: any)=> item.value),
      amenities: fData?.amenities?.map((item: any) => item.value) || undefined,
      proposalDueBy: fData.proposalDueBy
        ? new Date(Date.parse(fData.proposalDueBy))
        : undefined,
      interiorType: fData?.interiorType?.map((item: any) => item.value) || undefined,
      facilityType: fData?.facilityType?.value || undefined,
      minSeats: fData.minSeats || undefined,
      maxSeats: fData.maxSeats || undefined,
      weightage: fData.weightage || undefined,
      specialRequirements: fData?.specialRequirements || undefined,
      leadId: props?.leadId,
      parentId,
      companyId,
      customerId: props?.customerId,
    };
  };

  const updateFormWithEditedData = (data: any) => {
    // reset(data);
  };

  const onSubmit = async (data: FormData) => {
    // Call your API to save the form data
    setSaving(true);
    setFormData(data);
    updateFormWithEditedData(data);
    // if (isRequirementEdit) {
    //   setIsRequirementEdit(!isRequirementEdit);
    //   const formatedFormData = getFormatedFormData(data);
    //   try {
    //     const reponse = await api.AddNewRequirement.createRequirements(
    //       formatedFormData
    //     );
    //     if (reponse) {
    //       toastr.success("Success", "Requirements Edited Successfully");
    //       setConfirmResData(reponse);
    //       setParentId(reponse._id);
    //       setOnConfirm(true);
    //       props.onClose?.();
    //       props.onReload?.();
    //       setApprovalButtonDiabled(false);
    //     }
    //   } catch (error) {
    //     setApprovalButtonDiabled(false);
    //     toastr.error("Error", "Failed to create requirements");
    //     // console.log("Failed to create requirements:", error);
    //   }
    // } 
    // else {
    setIsEdit(true);
    // }
    setSaving(false);
  };

  const onConfirmation = async (fData: FormData) => {
    setApprovalButtonDiabled(true);
    updateFormWithEditedData(fData);
    const formatedFormData = getFormatedFormData(fData);

    try {
      const reponse = await api.AddNewRequirement.createRequirements(
        formatedFormData
      );

      if (reponse) {
        setParentId(reponse._id);
        toastr.success("Success", "Requirements created successfully");
        history.push(`${RouteKeys.Requirement.replace(":id", reponse._id)}`);
        setConfirmResData(reponse);
        // reset();
        props.onClose?.();
        props.onReload?.();
        setApprovalButtonDiabled(false);
      }
    } catch (error) {
      setApprovalButtonDiabled(false);
      toastr.error("Error", "Failed to create requirements");
    }
  };

  return (
    <Fragment>
      {isEdit ? (
        <NewRequirementPreview
          className="row mx-0"
          formData={formData}
          onClose={props?.onClose}
          onEdit={() => setIsEdit(!isEdit)}
          onConfirmation={() => onConfirmation(formData)}
          approvalButtonDiabled={approvalButtonDiabled}
          leadIntent={props?.lead?.leadIntent}
        />
      ) : (
        <div className="modal-open">
          <div
            className="detail-poupup bg-white position-fixed top-0 h-100 overflow-auto in"
            style={{ width: "95%" }}
          >
            <div className="container-fluid bg-gray-100 border-bottom py-3 position-sticky top-0 zIndex-99">
              <div className="row align-items-center">
                <div
                  className="col-auto"
                  onClick={() => {
                    props.onClose?.();
                  }}
                >
                  <i className="icon-close text-gray-500 font-xxl cursor-pointer"></i>
                </div>
                <div className="col">
                  <h2 className="mb-0"> Create Requirement</h2>
                  {/* {props?.lead?.leadIntent?.name} */}
                </div>

                <div className="mt-md-0 ml-auto col-auto">
                  <button
                    onClick={() => {
                      setIsReset(true);
                      setResetForm(true)
                      setFormData(initialData);
                    }}
                    disabled={isReset}
                    className="btn btn-primary px-3 mr-2 font-normal font-weight-bold py-2 rounded"
                  >
                    Reset
                  </button>
                </div>
              </div>
            </div>

            <div className={`${props.className || ""} h-100 `}>
              <div className="col-12">
                <div className=" pt-3 pb-12">
                  {showForm &&
                    <NewRequirementForm
                      onSubmit={onSubmit}
                      onClose={props?.onClose}
                      formData={formData}
                      isRequirementEdit={isRequirementEdit}
                      cities={cities}
                      microMarketsData={microMarketsData}
                      preferredLocationsData={preferredLocationsData}
                      projectType={projectType}
                      propertyType={propertyType}
                      preferredDevelopers={preferredDevelopers}
                      floorPreferences={floorPreferences}
                      preferredProject={preferredProject}
                      amenities={amenities}
                      facilities={facilities}
                      handleCityZones={handleCityZones}
                      leadIntent={props?.lead?.leadIntent}
                      saving={saving}
                      requirements={lead}
                      isReset={isReset}
                      resetForm={resetForm}
                      setReset={(val: boolean) => setIsReset(val)}
                      setResetForm={(val: boolean) => setResetForm(val)}
                    />
                  }
                </div>
              </div>
            </div>
          </div>

          <div className="modal-backdrop fade show"></div>
        </div>
      )}
    </Fragment>
  );
};

export default AddNewRequirements;
